// extracted by mini-css-extract-plugin
module.exports = {"currency":"styles__currency___2PV52","currencyCode":"styles__currencyCode___2JoDe"};